import React from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import FreeBox from "@/components/box/freeBox";

function AdminDashboardMemberPage(props) {

    return (
        <AdminLayout pageTitle={'اعضا'}>
            <FreeBox>داشبورد اعضا</FreeBox>
        </AdminLayout>
    );
}

export default AdminDashboardMemberPage;